import { CompanyDetailsFormGzDataProvider } from '../dataProvider/CompanyDetailsFormGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class CompanyDetailsFormDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, CompanyDetailsFormGzDataProvider);
  }
}
